export const EASING = "cubic-bezier(0.4, 0, 0.2, 1)";
export const FADE_MS = 600;
export const MIN_DISPLAY_MS = 3200;
export const SPLASH_SESSION_KEY = "new_design_splash_seen";
export const SPLASH_Z_INDEX = 10_000;

export const palette = {
  night0: "#1C1E48",
  night1: "#2F2C60",
  night2: "#474178",
  duskTop: "#EAE8F6",
  duskMid: "#CFCDEC",
  duskDeep: "#BBB8E3",
  duskLow: "#F4E7EA",
  horizon: "#FADFBE",
  hillFar: "#9FAFB4",
  hillMid: "#6E8590",
  sunGlow: "#FFF7ED",
  mist: "#F6F1EE",
  mark: "#03542C",
} as const;

export const KEYFRAMES_CSS = `
  @keyframes nightLift {
    to { opacity: 0; }
  }
  @keyframes sunRise {
    from { transform: translateY(46vh) scale(0.9); }
    to   { transform: translateY(-28vh) scale(1.5); }
  }
  @keyframes coreDissolve {
    to { opacity: 0; filter: blur(26px); }
  }
  @keyframes glowDissolve {
    to { opacity: 0.55; filter: blur(26px); }
  }
  @keyframes sunBreathe {
    from { opacity: 1; }
    to   { opacity: 0.86; }
  }
  @keyframes fadeIn {
    to { opacity: 1; }
  }
  @keyframes fogSpin {
    to { transform: rotate(360deg); }
  }
  @keyframes fogSway {
    from { transform: rotate(-26deg); }
    to   { transform: rotate(26deg); }
  }
  @keyframes wispClear {
    to { opacity: var(--fend); }
  }
  @keyframes peachBloom {
    to { opacity: 0.85; }
  }
  @keyframes crestDraw {
    0%   { stroke-dashoffset: 1; opacity: 0; }
    10%  { opacity: 0.95; }
    100% { stroke-dashoffset: 0; opacity: 0.95; }
  }
  @keyframes crestSettle {
    to { opacity: 0.28; }
  }
  @keyframes fillDissolve {
    to { opacity: var(--fo); }
  }
  @keyframes letterRise {
    0%   { transform: translateY(130px); }
    64%  { transform: translateY(-5px); }
    84%  { transform: translateY(2px); }
    100% { transform: translateY(0); }
  }
  @keyframes nDraw {
    to { stroke-dashoffset: 0; }
  }
`;
